import { TZDateMini } from '@date-fns/tz';
import { addDays, addMonths, differenceInMonths, isValid } from 'date-fns';
import { timeZone } from 'src/utils/date-time-format';

export function getCurrentGasDayDate(now: number) {
  const berlinDate = new TZDateMini(now, timeZone);
  berlinDate.setHours(6);
  berlinDate.setMinutes(0);
  berlinDate.setSeconds(0);
  berlinDate.setMilliseconds(0);

  if (berlinDate.getTime() > now) {
    return addDays(berlinDate, -1);
  }

  return berlinDate;
}

export function getPreviousGasDay(now: number) {
  const currentGasDay = getCurrentGasDayDate(now);
  return addDays(currentGasDay, -1).toISOString();
}

export function getNextGasDayDate(now: number) {
  const currentGasDay = getCurrentGasDayDate(now);
  return addDays(currentGasDay, 1);
}

export function isGasDay(localDate: string | null) {
  if (!localDate) return false;

  const berlinDate = new TZDateMini(localDate, timeZone);
  return (
    isValid(berlinDate) &&
    berlinDate.getHours() === 6 &&
    berlinDate.getMinutes() === 0 &&
    berlinDate.getSeconds() === 0 &&
    berlinDate.getMilliseconds() === 0
  );
}

export function isGasMonth(localDate: string | null) {
  if (!localDate) return false;

  const berlinDate = new TZDateMini(localDate, timeZone);
  return (
    isValid(berlinDate) &&
    berlinDate.getDate() === 1 &&
    berlinDate.getHours() === 6 &&
    berlinDate.getMinutes() === 0 &&
    berlinDate.getSeconds() === 0 &&
    berlinDate.getMilliseconds() === 0
  );
}

export function isSingleGasMonth(
  localDateStart: string | null,
  localDateEnd: string | null
) {
  if (
    !localDateStart ||
    !localDateEnd ||
    !isGasMonth(localDateStart) ||
    !isGasMonth(localDateEnd)
  )
    return false;

  const berlinDateStart = new TZDateMini(new Date(localDateStart), timeZone);
  const berlinDateEnd = new TZDateMini(new Date(localDateEnd), timeZone);

  return differenceInMonths(berlinDateStart, berlinDateEnd) === -1;
}

export function getNextGasMonth(localDate: Date) {
  const berlinDate = new TZDateMini(localDate, timeZone);
  berlinDate.setDate(1);
  berlinDate.setHours(6);
  berlinDate.setMinutes(0);
  berlinDate.setSeconds(0);
  berlinDate.setMilliseconds(0);

  if (berlinDate <= localDate) {
    return addMonths(berlinDate, 1);
  }

  return berlinDate;
}
